import src from "IMAGE";
export default { src, width: 1278, height: 900, blurWidth: 8, blurHeight: 6, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAYAAAD+Bd/7AAAASUlEQVR42m3JwQkAMQgAQWuICRFFxP5LzKGnfx8LCwPu/plZTpU9UNUQkZxqA2YOIsqpNrj3xjknp9qgJhAxp9pg7/3WWjGFZT/zUz0bae0qiAAAAABJRU5ErkJggg=="};
